// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RestrictedAccess_container__e8Ueh {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #000000;
    font-family: 'Arial', sans-serif;
  }
  
  .RestrictedAccess_card__sDa2j {
    background-color: rgba(30, 30, 30, 0.9);
    border-radius: 10px;
    padding: 2rem;
    box-shadow: 0 0 20px rgba(255, 0, 0, 0.3);
    text-align: center;
    max-width: 90%;
    width: 400px;
    animation: RestrictedAccess_fadeIn__uFIJr 0.8s ease-in-out;
  }
  
  .RestrictedAccess_title__R6rtm {
    color: #ff0000;
    font-size: 2rem;
    margin-bottom: 1rem;
    text-transform: uppercase;
    letter-spacing: 2px;
    animation: RestrictedAccess_pulse__uDKiZ 2s infinite;
  }
  
  .RestrictedAccess_message__Sut9s {
    color: #ffffff;
    font-size: 1.1rem;
    line-height: 1.5;
    margin-bottom: 2rem;
    opacity: 0;
    animation: RestrictedAccess_slideUp__L6K6g 0.8s ease-out forwards;
    animation-delay: 0.3s;
  }
  
  .RestrictedAccess_icon__aWt9o {
    font-size: 3rem;
    color: #ff0000;
    margin-bottom: 1.5rem;
    animation: RestrictedAccess_rotate__dH3QC 1s ease-in-out;
  }
  
  .RestrictedAccess_button__O2ofo {
    background-color: #ff0000;
    color: white;
    border: none;
    padding: 0.8rem 2rem;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
    opacity: 0;
    animation: RestrictedAccess_fadeIn__uFIJr 0.8s ease-out forwards;
    animation-delay: 0.6s;
  }
  
  .RestrictedAccess_button__O2ofo:hover {
    background-color: #cc0000;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(255, 0, 0, 0.3);
  }
  
  @keyframes RestrictedAccess_fadeIn__uFIJr {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  @keyframes RestrictedAccess_slideUp__L6K6g {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes RestrictedAccess_pulse__uDKiZ {
    0% {
      text-shadow: 0 0 10px rgba(255, 0, 0, 0.5);
    }
    50% {
      text-shadow: 0 0 20px rgba(255, 0, 0, 0.8);
    }
    100% {
      text-shadow: 0 0 10px rgba(255, 0, 0, 0.5);
    }
  }
  
  @keyframes RestrictedAccess_rotate__dH3QC {
    from {
      transform: rotate(-180deg);
      opacity: 0;
    }
    to {
      transform: rotate(0);
      opacity: 1;
    }
  }
  
  @media (max-width: 480px) {
    .RestrictedAccess_card__sDa2j {
      padding: 1.5rem;
    }
    
    .RestrictedAccess_title__R6rtm {
      font-size: 1.5rem;
    }
    
    .RestrictedAccess_message__Sut9s {
      font-size: 1rem;
    }
    
    .RestrictedAccess_button__O2ofo {
      padding: 0.6rem 1.5rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/private/RestrictedAccess.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,uCAAuC;IACvC,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,0DAAkC;EACpC;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,oDAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,iEAAyC;IACzC,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,wDAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,UAAU;IACV,gEAAwC;IACxC,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,2CAA2C;EAC7C;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,0CAA0C;IAC5C;IACA;MACE,0CAA0C;IAC5C;IACA;MACE,0CAA0C;IAC5C;EACF;;EAEA;IACE;MACE,0BAA0B;MAC1B,UAAU;IACZ;IACA;MACE,oBAAoB;MACpB,UAAU;IACZ;EACF;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,sBAAsB;IACxB;EACF","sourcesContent":[".container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    background-color: #000000;\n    font-family: 'Arial', sans-serif;\n  }\n  \n  .card {\n    background-color: rgba(30, 30, 30, 0.9);\n    border-radius: 10px;\n    padding: 2rem;\n    box-shadow: 0 0 20px rgba(255, 0, 0, 0.3);\n    text-align: center;\n    max-width: 90%;\n    width: 400px;\n    animation: fadeIn 0.8s ease-in-out;\n  }\n  \n  .title {\n    color: #ff0000;\n    font-size: 2rem;\n    margin-bottom: 1rem;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    animation: pulse 2s infinite;\n  }\n  \n  .message {\n    color: #ffffff;\n    font-size: 1.1rem;\n    line-height: 1.5;\n    margin-bottom: 2rem;\n    opacity: 0;\n    animation: slideUp 0.8s ease-out forwards;\n    animation-delay: 0.3s;\n  }\n  \n  .icon {\n    font-size: 3rem;\n    color: #ff0000;\n    margin-bottom: 1.5rem;\n    animation: rotate 1s ease-in-out;\n  }\n  \n  .button {\n    background-color: #ff0000;\n    color: white;\n    border: none;\n    padding: 0.8rem 2rem;\n    border-radius: 5px;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    text-decoration: none;\n    display: inline-block;\n    opacity: 0;\n    animation: fadeIn 0.8s ease-out forwards;\n    animation-delay: 0.6s;\n  }\n  \n  .button:hover {\n    background-color: #cc0000;\n    transform: translateY(-2px);\n    box-shadow: 0 5px 15px rgba(255, 0, 0, 0.3);\n  }\n  \n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n  \n  @keyframes slideUp {\n    from {\n      opacity: 0;\n      transform: translateY(20px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  @keyframes pulse {\n    0% {\n      text-shadow: 0 0 10px rgba(255, 0, 0, 0.5);\n    }\n    50% {\n      text-shadow: 0 0 20px rgba(255, 0, 0, 0.8);\n    }\n    100% {\n      text-shadow: 0 0 10px rgba(255, 0, 0, 0.5);\n    }\n  }\n  \n  @keyframes rotate {\n    from {\n      transform: rotate(-180deg);\n      opacity: 0;\n    }\n    to {\n      transform: rotate(0);\n      opacity: 1;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .card {\n      padding: 1.5rem;\n    }\n    \n    .title {\n      font-size: 1.5rem;\n    }\n    \n    .message {\n      font-size: 1rem;\n    }\n    \n    .button {\n      padding: 0.6rem 1.5rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RestrictedAccess_container__e8Ueh`,
	"card": `RestrictedAccess_card__sDa2j`,
	"fadeIn": `RestrictedAccess_fadeIn__uFIJr`,
	"title": `RestrictedAccess_title__R6rtm`,
	"pulse": `RestrictedAccess_pulse__uDKiZ`,
	"message": `RestrictedAccess_message__Sut9s`,
	"slideUp": `RestrictedAccess_slideUp__L6K6g`,
	"icon": `RestrictedAccess_icon__aWt9o`,
	"rotate": `RestrictedAccess_rotate__dH3QC`,
	"button": `RestrictedAccess_button__O2ofo`
};
export default ___CSS_LOADER_EXPORT___;
